import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { AssetDataField, IAssetData } from '@telespot/sdk';

export interface Field {
  displayName: string;
  fieldPath: string;
  value: number;
}

@Component({
    selector: 'ts-acquisition-data',
    templateUrl: './acquisition-data.component.html',
    styleUrls: ['./acquisition-data.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AcquisitionDataComponent implements OnChanges {
  @Input() public readonly isEditable: boolean;
  @Input() public readonly editMode: boolean;
  @Input() public readonly acquisitionData: IAssetData;
  @Input() public readonly assetFields: AssetDataField[];

  @Output() public readonly saveData = new EventEmitter<void>();
  @Output() public readonly discardChanges = new EventEmitter<void>();
  @Output() public readonly editionMode = new EventEmitter<boolean>();
  @Output() public readonly fieldChange = new EventEmitter<{ fieldPath: string; value: any }>();

  public fields: Field[];

  ngOnChanges(changes: SimpleChanges) {
    const { acquisitionData } = changes;

    if (!acquisitionData) return;

    if (acquisitionData.currentValue === acquisitionData.previousValue) return;

    this._initFields();

    return;
  }

  private _initFields() {
    this.fields = this.assetFields.map((assetField) => ({
      displayName: assetField.displayName,
      fieldPath: assetField.fieldPath,
      value: this._extractFieldValue(assetField.fieldPath, this.acquisitionData) || 0,
    }));
  }

  trackByFieldPath(_index: number, field: Field): string {
    return field.fieldPath;
  }

  private _extractFieldValue(fieldPath, acquisitionData) {
    const keys = fieldPath.split('.');

    for (const key of keys) {
      if (!Object.keys(acquisitionData).includes(key)) return null;

      acquisitionData = acquisitionData[key];
    }
    return acquisitionData;
  }

  public onSave() {
    this.saveData.emit();
    this.editionMode.emit(false);
  }

  public onDiscard() {
    this.discardChanges.emit();
    this.editionMode.emit(false);
  }

  public onFieldChange(field: Field, newValue: any) {
    const assetField = this.assetFields.find((af) => af.fieldPath === field.fieldPath);
    if (assetField) {
      this.fieldChange.emit({
        fieldPath: assetField.fieldPath,
        value: newValue,
      });
    }
  }
}
